<template>
  <CBox
    width="100%"
    bg="var(--colors-light-primary-light-gray)"
    border="0.5px solid var(--colors-light-secondary-divider)"
    border-radius="8px"
    px="16px"
    py="8px"
    @click="handleClick"
    :cursor="disabled ? 'not-allowed' : 'pointer'"
    :opacity="disabled ? 0.5 : 1"
    :data-tour="dataTour || undefined"
  >
    <CFlex align-items="center" justify-content="space-between">
      <CFlex align-items="center">
        <CBox
          w="16px"
          h="16px"
          border-radius="50%"
          :bg="isLocationDisabled ? 'rgba(255, 116, 0, 0.1)' : 'rgba(28, 160, 255, 0.15)'"
          display="flex"
          align-items="center"
          justify-content="center"
          mr="10px"
        >
          <CBox
            :bg="isLocationDisabled ? '#FF7400' : 'var(--colors-light-support-news)'"
            w="8px"
            h="8px"
            border-radius="50%"
          />
        </CBox>
        <CBox>
          <OmtTypography as="h3-bold"> {{ title }} </OmtTypography>
          <OmtTypography v-if="isLocationDisabled" as="p2" color="var(--colors-light-primary-gray1)">
            Localização desativada. Precisamos acessá-la para encontrar prestadores próximos a você.
          </OmtTypography>
          <OmtTypography v-else as="p2"> {{ subtitle }} </OmtTypography>
        </CBox>
      </CFlex>
      <OmtIcons name="chevron-down" size="xs" v-if="!disabled" />
    </CFlex>
  </CBox>
</template>

<script>
export default {
  name: "LocationCard",
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isLocationDisabled: {
      type: Boolean,
      default: false
    },
    dataTour: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleClick() {
      if (!this.disabled) {
        this.$emit("click");
      }
    }
  }
};
</script>
